// ServiceNear support contacts - one list for the Contact Us page and the sign-up page "Contact us for help" sheet

export interface ServicenearSupportContact {
  label: string;
  /** With country code, no "+" (used for tel: and wa.me links) */
  phone: string;
}

export const SERVICENEAR_SUPPORT_CONTACTS: ServicenearSupportContact[] = [
  { label: 'Care Contact 1', phone: '919633223355' },
  { label: 'Care Contact 2', phone: '919633777066' },
  { label: 'Care Contact 3', phone: '919895070723' },
];

export const SERVICENEAR_SUPPORT_HOURS = 'Calls 9 AM - 7 PM · WhatsApp anytime';

export const SERVICENEAR_HELP_VIDEO_URL = 'https://youtube.com/playlist?list=PLcWdOeOoSgudCbOaSRv295JoyAibjUUQR&si=g3LV2dUcsFy7IEp_';

/** "+91 96332 23355" */
export function formatSupportPhone(phone: string): string {
  const local = phone.startsWith('91') && phone.length === 12 ? phone.slice(2) : phone;
  return local.length === 10 ? `+91 ${local.slice(0, 5)} ${local.slice(5)}` : `+${phone}`;
}
